import React, { useEffect, useState } from "react";
import { IsAlert } from "../component/atoms/IsAlert";
import {
  Chip,
  TableContainer,
  TablePagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import { fetchApi } from "../helper/api";

const defaultDataAudit = {
  metaPagination: {
    currentPage: 0,
    dataCount: null,
    info: null,
    maxPage: null,
    pageSize: null,
  },
  auditRes: [],
};

function SystemAudit() {
  // inisiasi variabel
  const [dataAudit, setDataAudit] = useState(defaultDataAudit);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchAuditData = async () => {
    const req = await fetchApi(
      `api/Audit?page=${page + 1
      }&pageSize=${rowsPerPage}`,
      "get",
      true
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      console.log("DATA AUDIT", res.data);
      setDataAudit(res.data);
    } else {
      // console.log("ERROR FETCH HISTORY");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value;
    setRowsPerPage(parseInt(value, 10));
    setPage(0);
  };

  const getFullTime = (ts) => {
    const time = new Date(ts)
    return time.toLocaleString()
  }

  useEffect(() => {
    fetchAuditData();
    console.log("Render Audit");
  }, []);

  useEffect(() => {
    fetchAuditData();
    setPage(0);
  }, [rowsPerPage]);

  useEffect(() => {
    fetchAuditData();
  }, [page]);

  const renderChipAction = (action) => {
    switch (action) {
      case "Create":
        return <Chip label={action} color="success" />
      case "Delete":
        return <Chip label={action} color="error" />
      case "Update":
        return <Chip label={action} color="info" />
      case "Error":
        return <Chip label={action} color="error" />
      default:
        return <Chip label={action} color="primary" />
    }
  }

  return (
    <div className="p-2">
      <h1 className='mb-2'>System Audit</h1>
      <Paper sx={{ borderRadius: "1rem" }} className="shadow">
        <TableContainer>
          <Table
            sx={{ minWidth: 650 }} aria-label="simple-table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Email</TableCell>
                <TableCell align="center">Collection</TableCell>
                <TableCell align="center">At</TableCell>
                <TableCell align="center">Action</TableCell>
                <TableCell align="right">Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataAudit?.auditRes?.map((item, i) => (
                <TableRow
                  key={item._id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {item.email}
                  </TableCell>
                  <TableCell align="center">{item.collection}</TableCell>
                  <TableCell align="center">{getFullTime(item.createdAt)}</TableCell>
                  <TableCell align="center">{renderChipAction(item.action)}</TableCell>
                  <TableCell align="right">{item.description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          className="pagination"
          count={dataAudit?.metaPagination?.dataCount ?? 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  )
}
export default SystemAudit